import { getConfig } from "./config";

const parseResponse = async (res) => {
  const text = await res.text();
  let data = {};

  if (text) {
    try {
      data = JSON.parse(text);
    } catch (error) {
      data = { raw: text };
    }
  }

  if (!res.ok) {
    return {
      Success: false,
      Message: data?.Message || data?.message || "Request failed.",
      ...data,
    };
  }

  return data;
};

export const createKnowledgeEvent = async (payload) => {
  try {
    const config = await getConfig();
    const formData = new FormData();

    formData.append("Title", payload.title || "");
    formData.append("Description", payload.description || "");
    formData.append("EventDate", payload.eventDate || "");

    if (payload.image) {
      formData.append("Image", payload.image);
    }

    const res = await fetch(`${config.baseUrl}${config.knowledgeCenter.createEvent}`, {
      method: "POST",
      body: formData,
    });

    return await parseResponse(res);
  } catch (error) {
    return {
      Success: false,
      Message: error.message,
    };
  }
};

export const getAllKnowledgeEvents = async () => {
  try {
    const config = await getConfig();

    const res = await fetch(`${config.baseUrl}${config.knowledgeCenter.getAll}`, {
      method: "GET",
      cache: "no-store",
    });

    return await parseResponse(res);
  } catch (error) {
    return {
      Success: false,
      Message: error.message,
    };
  }
};

export const deleteKnowledgeEvent = async (id) => {
  try {
    const config = await getConfig();

    const res = await fetch(`${config.baseUrl}${config.knowledgeCenter.delete}?id=${id}`, {
      method: "DELETE",
      cache: "no-store",
    });

    return await parseResponse(res);
  } catch (error) {
    return {
      Success: false,
      Message: error.message,
    };
  }
};
